toggleMap = {
    init() {
        const map = document.querySelector(".mapButton");
        const list = document.querySelector(".listButton");
        const acfMap = document.querySelector(".acf-map");
        const ecoleList = document.querySelector(".ecoles_list");

        map.addEventListener("click", () => {
            list.classList.toggle("is-visible");
            map.classList.toggle("is-visible");
            acfMap.classList.toggle("is-visible");
            ecoleList.classList.toggle("is-visible");
        });

        
        list.addEventListener('click', () => {
            map.classList.toggle("is-visible");
            list.classList.toggle("is-visible");
            acfMap.classList.toggle("is-visible");
            ecoleList.classList.toggle("is-visible");
        })
    }
}
export let toggleMap;